<template>
    <div class="container py-10 lg:pt-[100px] lg:pb-[50px]">
        <div v-if="heading" class="pb-5 lg:pb-10">
            <h2>{{ heading }}</h2>
        </div>
        <div v-if="mainbody" v-html="mainbody" v-epi-edit="'MainBody'"
             class="c-start text-center font-light text-3xl mb-12 text-gray-700"/>
        <div class="grid lg:grid-cols-2 gap-5">
            <startpage-modern-item v-for="item in items" :key="item.id" :item="item"/>
        </div>
    </div>
</template>

<script>
import startpageModernItem from './startpageModernItem.vue';

export default {
    components: {startpageModernItem},
    props: ['categories', 'mainbody', 'heading'],
    data() {
        return {
            items: this.categories.filter(cat => !cat.hideStartpage)
        };
    },
    methods: {
        style(item) {
            return `border-4 border-${item.color}-500 hover:bg-${item.color}-500`;
        }
    }
};
</script>
